export const fr = {
  nav: {
    home: "Accueil",
    about: "À propos",
    skills: "Compétences",
    projects: "Projets",
    experience: "Expérience",
    contact: "Contact",
    portfolio: "Portfolio",
    light: "Clair",
    dark: "Sombre",
    english: "Anglais",
    arabic: "Arabe",
    french: "Français",
  },

  loading: {
    message: "Chargement du portfolio…",
  },

  hero: {
    title: "Mokhles Lajimi",
    eyebrow: "Bonjour, je suis",
    subtitle: "Développeur Full Stack Mobile & Web",
    availableBadge: "Disponible en Freelance",
    recentLaunches: "Lancements récents",
    metricYears: "Ans d'exp.",
    metricProjects: "Projets",
    metricStores: "Play & App Store",
    description:
      "Développeur Mobile Full Stack avec 5+ années d'expérience dans le développement d'applications Flutter haute performance et de backends évolutifs. Je me concentre sur une UX fluide, des flux de données fiables et une livraison prête pour la production sur Android, iOS et le web.",
    downloadCV: "Télécharger CV",
    contactWhatsApp: "Contacter via WhatsApp",
  },
  about: {
    title: "À propos de moi",
    description1:
      "Je suis un développeur passionné avec 5+ années d'expérience créant des solutions numériques qui font la différence. Je me spécialise dans le développement mobile Flutter et j'adore transformer des problèmes complexes en designs simples et élégants.",
    description2:
      "Quand je ne code pas, vous pouvez me trouver en train d'explorer de nouvelles technologies, contribuer à des projets open source, ou partager mes connaissances avec la communauté des développeurs. Je suis toujours désireux d'apprendre et de grandir dans ce domaine en constante évolution.",
    stats: [
      { number: "18+", label: "Projets Terminés" },
      { number: "5+", label: "Années d'Expérience" },
      { number: "100%", label: "Satisfaction Client" },
    ],
  },
  skills: {
    title: "Compétences",
    subtitle: "Ma stack au quotidien",
    categories: [
      {
        category: "Développement Mobile",
        icon: "📱",
        description: "Applications natives et cross-platform",
        skills: [
          { name: "Flutter", level: 92, color: "#02569B" },
          { name: "Dart", level: 88, color: "#0175C2" },
          { name: "Kotlin", level: 72, color: "#7F52FF" },
          { name: "Swift", level: 68, color: "#FA7343" },
          { name: "Android", level: 82, color: "#3DDC84" },
          { name: "iOS", level: 78, color: "#000000" },
        ],
      },
      {
        category: "Développement Frontend",
        icon: "💻",
        description: "Interfaces web modernes",
        skills: [
          { name: "React.js", level: 88, color: "#61DAFB" },
          { name: "TypeScript", level: 82, color: "#3178C6" },
          { name: "Next.js", level: 75, color: "#000000" },
          { name: "Tailwind CSS", level: 85, color: "#06B6D4" },
          { name: "HTML5", level: 90, color: "#E34F26" },
          { name: "CSS3", level: 88, color: "#1572B6" },
        ],
      },
      {
        category: "Développement Backend",
        icon: "🔧",
        description: "Solutions serveur robustes",
        skills: [
          { name: "Node.js", level: 85, color: "#339933" },
          { name: "Express", level: 82, color: "#000000" },
          { name: "Python", level: 80, color: "#3776AB" },
          { name: "Flask", level: 75, color: "#000000" },
          { name: "REST APIs", level: 88, color: "#FF6B6B" },
          { name: "GraphQL", level: 70, color: "#E10098" },
          { name: "WebSockets", level: 78, color: "#010101" },
        ],
      },
      {
        category: "Données & Cloud",
        icon: "☁️",
        description: "Solutions de données évolutives",
        skills: [
          { name: "MongoDB", level: 82, color: "#47A248" },
          { name: "PostgreSQL", level: 78, color: "#336791" },
          { name: "Firebase", level: 85, color: "#FFCA28" },
          { name: "Retool", level: 70, color: "#FF6B35" },
          { name: "CI/CD", level: 72, color: "#2088FF" },
          { name: "Docker", level: 68, color: "#2496ED" },
          { name: "Git", level: 90, color: "#F05032" },
        ],
      },
    ],
    additionalExpertise: "Aussi",
    additionalSubtitle: "",
    additionalSkills: [
      "Agile/Scrum",
      "Conception UI/UX",
      "Test d'API",
      "Optimisation des Performances",
      "Gestion d'État",
      "Design Responsive",
      "Contrôle de Version",
      "Revue de Code",
      "Test & QA",
      "Gestion de Projet",
      "Communication Client",
      "Rédaction Technique",
    ],
  },
  projects: {
    title: "Projets",
    subtitle: "Sur Play Store, App Store et le web",
    countLabel: "projets",
    seeMore: "Voir plus",
    seeLess: "Réduire",
    categories: [
      { id: "all", name: "Tous les Projets", icon: "fas fa-th" },
      { id: "mobile", name: "Applications Mobiles", icon: "fas fa-mobile-alt" },
      { id: "web", name: "Applications Web", icon: "fas fa-globe" },
      { id: "game", name: "Jeux", icon: "fas fa-gamepad" },
    ],
    items: [
      {
        title: "Click Services",
        description:
          "Marketplace de services multilingue (15+ langues) : chat en temps réel, réservations, portefeuille et cashback, paiements sécurisés.",
        icon: "🛎️",
        category: "mobile",
        status: "En Ligne",
        users: "10K+",
        rating: "4.8",
        tech: [
          "Flutter",
          "Node.js",
          "MongoDB",
          "Stripe",
          "PayPal",
          "Socket.IO",
          "OneSignal",
        ],
        features: [
          "Chat Temps Réel",
          "Multi-langue",
          "Paiements Sécurisés",
          "Système de Portefeuille",
        ],
        links: [
          {
            text: "Play Store",
            url: "https://play.google.com/store/apps/details?id=com.ngtech.cliickservice",
            icon: "fab fa-google-play",
            type: "primary",
          },
          {
            text: "App Store",
            url: "https://apps.apple.com/us/app/click-services/id6744241291",
            icon: "fab fa-app-store-ios",
            type: "primary",
          },
        ],
      },
      {
        title: "Ritchess",
        description:
          "Suite de covoiturage (client, conducteur, admin) : réservation, suivi en direct, avis, zones, paiements, notifications.",
        icon: "🚗",
        category: "mobile",
        status: "En Ligne",
        users: "5K+",
        rating: "4.6",
        tech: [
          "Flutter",
          "Node.js",
          "Socket.IO",
          "MongoDB",
          "Provider",
          "GetX",
        ],
        features: [
          "Suivi en Direct",
          "Application Multi-rôle",
          "Intégration Paiement",
          "Mises à Jour Temps Réel",
        ],
        links: [
          {
            text: "Application Client",
            url: "https://play.google.com/store/apps/details?id=com.cinnov.ritchess",
            icon: "fab fa-google-play",
            type: "primary",
          },
        ],
      },
      {
        title: "Portfolio Web",
        description:
          "Portfolio personnel responsive avec mode sombre, animations fluides et design moderne.",
        icon: "💼",
        category: "web",
        status: "En Ligne",
        users: "1K+",
        rating: "5.0",
        tech: ["React", "CSS3", "JavaScript", "Responsive Design"],
        features: [
          "Design Responsive",
          "Mode Sombre",
          "Animations",
          "Performance Optimisée",
        ],
        links: [
          {
            text: "Voir le Site",
            url: "#",
            icon: "fas fa-external-link-alt",
            type: "primary",
          },
          {
            text: "Code Source",
            url: "#",
            icon: "fab fa-github",
            type: "secondary",
          },
        ],
      },
    ],
  },
  experience: {
    title: "Expérience Professionnelle",
    subtitle: "Croissance, propriété et impact dans le mobile et web",
    items: [
      {
        period: "09/2025 - Présent",
        title: "Développeur Mobile Flutter",
        company: "NexBuild, Tunisie",
        description:
          "Pilotage de la livraison d'applications mobiles cross‑platform avec Flutter, de l'implémentation UI/UX à partir des maquettes jusqu'aux mises en production sur Google Play et l'App Store. Participation à la planification des projets et à la rédaction des spécifications techniques, avec intégration d'APIs back‑end fiables et testées (Postman, Swagger).",
      },
      {
        period: "01/2024 - 09/2025",
        title: "Développeur Flutter Senior | Développeur Web Full Stack",
        company: "Converge Innova, Tunisie",
        description:
          "Responsable de bout en bout de produits mobiles et web : conception d'architectures Flutter et Node.js/MongoDB, déploiement en production et suivi des performances. Collaboration avec les équipes produit et design en Scrum, rédaction de spécifications techniques claires et validation des APIs via Postman et Swagger avant intégration côté mobile.",
      },
      {
        period: "02/2022 – 01/2024",
        title: "Développeur Flutter & Backend",
        company: "3D Wave Sousse, Tunisie",
        description:
          "Livraison d'applications Flutter en production sur Android et iOS, de la conception fonctionnelle jusqu'aux mises à jour. Développement et intégration d'APIs REST avec Node.js et Flask, travail en équipe Agile/Scrum et itération rapide sur de nouvelles fonctionnalités selon les retours clients.",
      },
      {
        period: "02/2021 – 11/2023",
        title: "Développeur Full Stack",
        company: "Lonch (FreeLance)",
        description:
          "Conception et réalisation d'outils internes et de tableaux de bord interactifs avec Retool, ainsi que de packages Flutter réutilisables pour accélérer les futurs projets. Intégration de frontends modernes avec des backends GraphQL/REST et gestion directe de la relation client et des livrables en tant que freelance full stack.",
      }
    ],
  },
  contact: {
    title: "On en parle ?",
    subtitle: "Une idée ? Je vous aide à la livrer.",
    methodWhatsApp: "Réponse rapide",
    methodEmail: "Email",
    methodLinkedIn: "LinkedIn",
    methods: [
      {
        name: "WhatsApp",
        url: "https://wa.me/21629060392",
        icon: "fab fa-whatsapp",
      },
      {
        name: "Email",
        url: "mailto:mokhleslajimi@gmail.com",
        icon: "fas fa-envelope",
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/mokhleslajimi/",
        icon: "fab fa-linkedin",
      },
    ],
    form: {
      action: "https://formsubmit.co/mokhleslajimi@gmail.com",
      fields: [
        { label: "Votre nom", placeholder: "Jean Dupont" },
        { label: "Email", placeholder: "jean@exemple.com" },
        { label: "Entreprise (optionnel)", placeholder: "Acme Inc." },
        {
          label: "Détails du projet",
          placeholder: "Que construisez-vous ?",
        },
      ],
      hint: "Réponse sous 24–48h.",
      submitText: "Envoyer le message",
    },
  },
  // Footer
  footer: {
    description:
      "Développeur mobile & web full stack — apps livrées en production.",
    socialLinks: [
      {
        name: "GitHub",
        url: "https://github.com/mokhleslajimi",
        icon: "fab fa-github",
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/mokhleslajimi/",
        icon: "fab fa-linkedin",
      },
      {
        name: "WhatsApp",
        url: "https://wa.me/21629060392",
        icon: "fab fa-whatsapp",
      },
    ],
    quickLinks: [
      { name: "Compétences", action: "scroll", target: "skills" },
      { name: "Projets", action: "scroll", target: "projects" },
      { name: "Expérience", action: "scroll", target: "experience" },
      {
        name: "Télécharger CV",
        action: "link",
        target: "dynamic_cv",
      },
    ],
    services: [
      "Développement d'Applications Mobiles",
      "Développement Web",
      "Développement Backend",
      "Conseil UI/UX",
      "Conseil Technique",
    ],
    copyright: "© 2025 Mokhles Lajimi. Tous droits réservés.",
    quickLinksTitle: "Liens Rapides",
    servicesTitle: "Services",
  },
};
